"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var Subject_1 = require("rxjs/Subject");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var EditorExpressionPopupComponent = /** @class */ (function () {
    function EditorExpressionPopupComponent(data, kbService, dialogRef) {
        this.data = data;
        this.kbService = kbService;
        this.dialogRef = dialogRef;
        this.expression = '';
        this.condition = '';
        this.emptyState = '';
        this._destroy$ = new Subject_1.Subject();
        this.expression = data.expression || '';
        this.condition = data.condition || '';
        this.emptyState = data.emptyState || '';
    }
    EditorExpressionPopupComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    EditorExpressionPopupComponent.prototype.save = function () {
        if (this.isValid()) {
            this.dialogRef.close({
                expression: this.expression,
                condition: this.condition,
                emptyState: this.emptyState,
            });
        }
    };
    EditorExpressionPopupComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.unsubscribe();
    };
    EditorExpressionPopupComponent.prototype.isValid = function () {
        this.expressionErrorFlag = this.expression.length === 0;
        return !this.expressionErrorFlag;
    };
    EditorExpressionPopupComponent = __decorate([
        core_1.Component({
            selector: 'sis-template-editor-expression-popup',
            template: require('./editor-expression-popup.component.html'),
            styles: [require('./editor-expression-popup.component.css')]
        }),
        __param(0, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [Object, idm_kb_service_client_js_1.KbService,
            material_1.MatDialogRef])
    ], EditorExpressionPopupComponent);
    return EditorExpressionPopupComponent;
}());
exports.EditorExpressionPopupComponent = EditorExpressionPopupComponent;
//# sourceMappingURL=editor-expression-popup.component.js.map